import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";

export const campaignColumns: GridColDef[] = [
  {
    field: "campaignName",
    headerName: "Campaign Details",
    width: 320,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "channel",
    headerName: "Channel",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "startDateTime",
    headerName: "Start time",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
    valueFormatter: (params) => {
      const date = new Date(params.value as string | number | Date);
      return isNaN(date.getTime()) ? "" : date.toLocaleString();
    },
  },
  {
    field: "totalSentByEvents",
    headerName: "Sent",
    width: 160,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "clickThroughConversions",
    headerName: "Engaged",
    width: 160,
    sortable: false,
    disableColumnMenu: true,
    valueGetter: (params: GridValueGetterParams<any, any>) => {
      const { channel, totalViewedByEvents, totalClickedByEvents } = params.row ?? {};
      if (channel === "InApp Notification") {
        return coerceNumber(totalViewedByEvents, 0);
      }
      return coerceNumber(totalClickedByEvents, 0);
    },
    valueFormatter: (params) =>
      typeof params.value === "number" ? params.value.toLocaleString() : params.value ?? "",
  },
  {
    field: "clickThroughConversionsPercentage",
    headerName: "Rate",
    width: 160,
    sortable: false,
    disableColumnMenu: true,
    valueGetter: (params: GridValueGetterParams<any, any>) => {
      const { channel, totalViewedByEvents, totalClickedByEvents, totalSentByEvents } = params.row ?? {};
      const viewed = channel === "InApp Notification" ? coerceNumber(totalViewedByEvents, 0) : coerceNumber(totalClickedByEvents, 0);
      const sent = coerceNumber(totalSentByEvents, 0);

      if (!Number.isFinite(viewed) || !Number.isFinite(sent) || sent <= 0) {
        return 0;
      }
      const pct = (viewed / sent) * 100;
      
      return Math.max(0, Math.min(100, pct));
    },
    valueFormatter: (params) => {
      const v = typeof params.value === "number" ? params.value : 0;
      
      return `${v.toFixed(2)}%`;
    },
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    sortable: false,
    disableColumnMenu: true,
  },
];

function coerceNumber(input: unknown, fallback = 0): number {
  if (input === null || input === undefined || input === "") return fallback;
  const n = Number(input);
  return Number.isFinite(n) ? n : fallback;
}
